<template>
  <div>
    <headerToolbar @toggleMenu="toggleMenu"></headerToolbar>
    <div class="content-container">
      <section 
        ref="content" 
        class="content" 
        v-loading="loading"
        element-loading-spinner="el-icon-loading"
        :element-loading-text="loading_text"
      >
        <router-view class="content-router" />
      </section>
      <navMenu 
        ref="menu" 
        class="side-menu" 
        :height="height"
      ></navMenu>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import HeaderToolbar from './components/HeaderToolbar'
import NavMenu from './components/NavMenu'

export default {
  name: "Index",
  components: { HeaderToolbar, NavMenu },
  data() {
    return {
      visibleMenu: true,
      height: document.body.scrollHeight,
      loading_table_count: 0,
      loading: false,
      isMessaging: false,
    }
  },
  watch: {
    loading_table_count: function(val) {
      if (val !== 0) { return; }
      this.$nextTick(() => this.loading = false);
    },
  },
  created() {
    this.init();
  },
  mounted() {
    window.addEventListener('resize', this.handleWindowResize);
    this.handleWindowResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this. handleWindowResize)
  }, 
  computed: {
    loading_text() {
      return !this.loading? '데이터를 불러오고 있습니다. 대기하시거나 로그아웃 후 다시 로그인 해 주시기 바랍니다.': '';
    }
  },
  methods: {
    ...mapActions(['getsLocalDb', 'setExpireTime', 'extendExpire']),
    init() {
      this.loading = true;
      let tables = this.$store.getters.tables;
      this.loading_table_count = tables.length; 
      tables.forEach(table => {
        this.getsLocalDb(table).then(() => {
          this.loading_table_count--;
        })
      });
    },
    toggleMenu() {
      this.visibleMenu = !this.visibleMenu;
      if (this.visibleMenu) {
        this.$refs.content.classList.remove('full');
        this.$refs.menu.$el.classList.remove('hide');
        this.$refs.content.classList.add('fix');
        this.$refs.menu.$el.classList.add('show');
      } else {
        this.$refs.content.classList.remove('fix');
        this.$refs.menu.$el.classList.remove('show');
        this.$refs.content.classList.add('full');        
        this.$refs.menu.$el.classList.add('hide');
      }
    },
    handleWindowResize() {
      this.$nextTick(() => {        
        this.height = document.body.scrollHeight - 50;
      })
    },
  }
}
</script>
